import React from 'react';
import '../styles/EmailProviderIcons.css';
import { Gmail, Outlook, Messages, Twilio } from '../assets/icons';

export function ProviderIcons({ icons }) {
    return (
        <div className="email-provider-icons">
            {icons.map((Icon, i) => (
                <span key={i} className="email-provider-icon"><Icon /></span>
            ))}
        </div>
    );
}

export function EmailProviderIcons() {
    return <ProviderIcons icons={[Gmail, Outlook]} />;
}

export function SmsProviderIcons() {
    return <ProviderIcons icons={[Messages, Twilio]} />;
}

export default EmailProviderIcons;
